import UserData from "../../../components/UserData/UserData";

export default function index() {
  return (
    <>
      <UserData />
    </>
  );
}
